import { useQuery } from '@tanstack/react-query'
import { getDivisions } from '@/lib/apiClients/inquiry'
import { queryKeys } from '@/lib/queryKeys'

interface UseDivisionsFilters {
  isEnabled?: boolean
  isAssignable?: boolean
}

export function useDivisions(filters?: UseDivisionsFilters) {
  return useQuery({
    queryKey: queryKeys.divisions(filters),
    queryFn: async () => {
      return getDivisions(filters)
    },
  })
}
